import { Card, Text } from '@etg/wings';
import { css, cx, getTextStyles } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const cardHeader = css`
  font-size: 1.125rem;
  font-weight: 700;
  margin-bottom: 16px;
`;
const amenitiesStyles = css`
  padding-inline-start: 8px;
`;
const DrawerCard = _ref => {
  let {
    cardTitle,
    children
  } = _ref;
  return /*#__PURE__*/_jsxs(Card, {
    padding: 16,
    children: [/*#__PURE__*/_jsx("h2", {
      className: cardHeader,
      children: cardTitle
    }), children]
  });
};
const LoungeDrawerContent = _ref2 => {
  var _loungeInfo$amenities, _loungeInfo$condition;
  let {
    drawerText,
    loungeInfo
  } = _ref2;
  const {
    openningFrom,
    openningTo,
    oppeningTitle,
    amenities: amenitiesText,
    location,
    condition: conditionText,
    terminal
  } = drawerText;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DrawerCard, {
      cardTitle: oppeningTitle,
      children: /*#__PURE__*/_jsxs(Text, {
        children: [openningFrom, " ", /*#__PURE__*/_jsx(Text, {
          variant: "14-bold",
          children: loungeInfo.openAt
        }), " ", openningTo, ' ', /*#__PURE__*/_jsx(Text, {
          variant: "14-bold",
          children: loungeInfo.closeAt
        })]
      })
    }), /*#__PURE__*/_jsx(DrawerCard, {
      cardTitle: amenitiesText,
      children: /*#__PURE__*/_jsx("ul", {
        className: cx(amenitiesStyles, getTextStyles()),
        children: (_loungeInfo$amenities = loungeInfo.amenities) === null || _loungeInfo$amenities === void 0 ? void 0 : _loungeInfo$amenities.map((amenity, index) => /*#__PURE__*/_jsx("li", {
          children: amenity === null || amenity === void 0 ? void 0 : amenity.name
        }, index))
      })
    }), /*#__PURE__*/_jsx(DrawerCard, {
      cardTitle: location,
      children: /*#__PURE__*/_jsx(Text, {
        children: `${terminal} ${loungeInfo.terminal}`
      })
    }), /*#__PURE__*/_jsx(DrawerCard, {
      cardTitle: conditionText,
      children: (_loungeInfo$condition = loungeInfo.conditions) === null || _loungeInfo$condition === void 0 ? void 0 : _loungeInfo$condition.map((condition, index) => /*#__PURE__*/_jsx(Text, {
        children: condition === null || condition === void 0 ? void 0 : condition.description
      }, index))
    })]
  });
};
export default LoungeDrawerContent;
//# sourceMappingURL=LoungeDrawerContent.js.map